import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { HeaderView } from '@merchant-backend/common-components'
import { Button, Radio, Input } from 'hljd'
import ImgGallery from '@common/ImgGallery'
import style from './style.module.less'
import store from './store'
import { toJS } from 'mobx'
import { Link } from 'react-router'

const RadioGroup = Radio.Group

@observer
export default class extends Component {
  componentDidMount() {
    store.getInfo()
  }

  render() {
    const header = [
      <Link to="/localMerchant/liteApp/manage">小程序</Link>,
      '小程序配置'
    ]
    const {
      title,
      photos,
      can_show_recommend,
      can_show_gift,
      can_show_feed,
      can_show_announcement
    } = store
    return (
      <HeaderView header={header} title="小程序设置">
        <div className={style.wrap}>
          <div className={style.imgBox}>
            <div className={style.outer}>
              <div className={style.inner}>
                <div className={style.img}>
                  <img src="http://qnm.hunliji.com/o_1bi5o8ehg1dnbmqr10gj10cjdkl7.png" />
                </div>
              </div>
              <img
                className={style.fixedImg}
                src="http://qnm.hunliji.com/o_1bi7qlkaq311r831ivn1pjueat7.jpg"
              />
            </div>
            <p>支持鼠标上下滚动预览</p>
          </div>
          <div className={style.box}>
            <p className={style.titleTip}>
              你可以自由设置店铺名称和轮播图，其余模块将自动同步你在婚礼纪平台上的设置，<br />你可设置模块显示/隐藏
            </p>

            <div className={style.item}>
              <span className={style.circle}>1</span>
              <span className={style.name}>店铺名称</span>
              <Input
                style={{ width: 300, height: 46 }}
                value={title}
                onChange={store.changeField('title')}
              />
              <span className={style.nameTip}>
                显示在小程序顶部导航上，建议与小程序注册时填写的名称保持一致
              </span>
            </div>
            <div className={style.item}>
              <span className={style.circle}>2</span>
              <span className={style.name}>轮播图</span>
              <div
                style={{
                  display: 'inline-block',
                  verticalAlign: 'top',
                  marginLeft: -5
                }}
              >
                <ImgGallery
                  max={3}
                  keyField="img"
                  multiple={true}
                  showUpload={photos.length < 3}
                  onRemove={store.removePhotos}
                  onOk={store.addPhotos}
                  imgList={toJS(photos)}
                />
              </div>
              <span className={style.pictureTip}>
                推荐尺寸640*300，最多上传三张，支持jpg、png格式，10M之内
              </span>
            </div>
            <div className={style.item}>
              <span className={style.circle}>3</span>
              <span className={style.name}>公告</span>
              <RadioGroup
                value={can_show_announcement}
                onChange={store.changeField('can_show_announcement')}
              >
                <Radio value={1}>显示</Radio>
                <Radio value={0}>隐藏</Radio>
              </RadioGroup>
            </div>
            <div className={style.item}>
              <span className={style.circle}>4</span>
              <span className={style.name}>到店礼</span>
              <RadioGroup
                value={can_show_gift}
                onChange={store.changeField('can_show_gift')}
              >
                <Radio value={1}>显示</Radio>
                <Radio value={0}>隐藏</Radio>
              </RadioGroup>
            </div>
            <div className={style.item}>
              <span className={style.circle}>5</span>
              <span className={style.name}>店铺推荐</span>
              <RadioGroup
                value={can_show_recommend}
                onChange={store.changeField('can_show_recommend')}
              >
                <Radio value={1}>显示</Radio>
                <Radio value={0}>隐藏</Radio>
              </RadioGroup>
            </div>
            <div className={style.item}>
              <span className={style.circle}>6</span>
              <span className={style.name}>动态</span>
              <RadioGroup
                value={can_show_feed}
                onChange={store.changeField('can_show_feed')}
              >
                <Radio value={1}>显示</Radio>
                <Radio value={0}>隐藏</Radio>
              </RadioGroup>
            </div>

            <div className={style.btn}>
              <Button
                style={{ marginRight: 12, height: 36 }}
                onClick={store.cancel}
              >
                取消修改
              </Button>
              <Button
                type="primary"
                style={{ height: 36 }}
                onClick={store.submit}
              >
                保存体验版
              </Button>
            </div>
          </div>
        </div>
      </HeaderView>
    )
  }
}
